import styled from 'styled-components';

export const A = styled.a` ${({ theme }) => `
    color: ${theme.textSecondary};
    text-decoration: none;
    margin:0;
`}`;

export const P = styled.p` ${({ theme }) => `
    color: ${theme.textNeutral};
    font-size: ${theme.fontSize[1]};
    margin:0;
`}`;

export const H3 = styled.h3` ${({ theme }) => `
    color: ${theme.textPrimary};
    font-size: ${theme.fontSize[7]};
    margin:0;
`}`;

export const H4 = styled.h4` ${({ theme }) => `
    color: ${theme.textPrimary};
    font-size: ${theme.fontSize[2]};
    margin:0;
`}`;
